export function getFilterTargetType(dataSourceMetadata) {
  const metadata = dataSourceMetadata !== null && dataSourceMetadata !== void 0 ? dataSourceMetadata : {};
  if ('filterTargetType' in metadata) {
    var _metadata$filterTarge;
    return (_metadata$filterTarge = metadata.filterTargetType) !== null && _metadata$filterTarge !== void 0 ? _metadata$filterTarge : 'ONE';
  } else if ('recordFilterDefinition' in metadata) {
    var _metadata$recordFilte;
    return (_metadata$recordFilte = metadata.recordFilterDefinition.filterTargetType) !== null && _metadata$recordFilte !== void 0 ? _metadata$recordFilte : 'ONE';
  } else {
    return 'ONE';
  }
}